import React from 'react';
import type { AfcSubmissionCandidateOpportunity } from '@axiom/validation';
import {
  CandidateAccolades,
  CandidatePerformanceFeedback,
  Card,
  CardHeader,
  CardSection,
  Gutter,
  Layout,
  Paragraph,
  ParagraphHeader,
  SmallHeader,
  Well,
  ReadonlyTextarea,
  CandidateReputationDoNotShowBanner,
  doNotShowBannerNames,
} from '@axiom/ui';

type CandidateReputationProps = {
  candidateOpp: AfcSubmissionCandidateOpportunity;
};

export const CandidateReputation = ({
  candidateOpp,
}: CandidateReputationProps) => {
  const {
    candidate,
    showCandidateReputation,
    candidateReputationClarification,
  } = candidateOpp;
  const { candidateReputation, showReputation } = candidate;
  const { displayCandidateReputation } = candidateReputation ?? {};
  const showRep = showReputation === true || showReputation === null;

  const setDisplay = () => {
    if (displayCandidateReputation && showCandidateReputation && showRep) {
      return (
        <Gutter top="24px">
          <CandidatePerformanceFeedback
            candidateReputation={candidateReputation}
          />
        </Gutter>
      );
    }

    if (!displayCandidateReputation && showCandidateReputation && showRep) {
      return (
        <CandidateReputationDoNotShowBanner
          name={doNotShowBannerNames.limitedFeedbackDisplay}
        />
      );
    }

    if (showCandidateReputation && !showRep) {
      return (
        <CandidateReputationDoNotShowBanner
          name={doNotShowBannerNames.optedOutDisplay}
          candidate={candidate}
        />
      );
    }

    return null;
  };

  return (
    <Card name="PERFORMANCE">
      <CardHeader>
        <SmallHeader>Axiom Performance</SmallHeader>
      </CardHeader>
      <CardSection>
        <Layout direction="vertical">
          <CandidateAccolades candidateReputation={candidateReputation} />
          {setDisplay()}
          {candidateReputationClarification?.submissionComments ? (
            <Gutter top="16px">
              <Well>
                <ParagraphHeader>
                  Axiom has provided context you may find helpful
                </ParagraphHeader>
                <Paragraph>
                  <ReadonlyTextarea
                    name="submissionComments"
                    value={candidateReputationClarification.submissionComments}
                  />
                </Paragraph>
              </Well>
            </Gutter>
          ) : null}
        </Layout>
      </CardSection>
    </Card>
  );
};
